// extracted by mini-css-extract-plugin
export default {"editorContent":"QKX9VbKO3tAG1739wkFD"};